export default "__VITE_PUBLIC_ASSET__f27e9f24__"